import React from "react";
import SideNav from "../components/SideNav/sideNav";
import Header from "../components/Header/hearder";
import { Wrapper } from "./layout.styles";
import ViewTopic from "../components/pages/Content/viewTopic";

const ViewTopicLayout = () => {
  return (
    <React.Fragment>
      <Header />
      <Wrapper>
        <SideNav />
        <div style={{margin: "70px 0px 0px 200px", width: "100%"}}>
        <ViewTopic />
        </div>
      </Wrapper>
    </React.Fragment>
  );
};

export default ViewTopicLayout;
